module.exports = __webpack_public_path__ + "static/media/nft_img.1191e584.png";